import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from "vue";
import { useServiceStore } from "@/stores/serviceStore";
import { ITermsInfo } from "@/domain/entities/serviceInfo/termsInfo";
import {
  TermsTypeCode,
  SESSION_KEY_TERMS_RESULT,
  PROVIDE_KEY_RESIZE_WEBVIEW,
  ResizeWebview,
} from "@/types";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import CheckboxInput from "@/components/shared/inputs/CheckboxInput.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import TermsDetail from "@/components/signup/TermsDetail.vue";
import useSetSessionStorageItem from "@/use/useSetSessionStorageItem";
import { ITermsResult } from "@/repositories/user/userRepository.types";
import { useRequestAuth } from "@/composables/shared/useRequestAuth";
import { inject } from "vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "TermsOfUse",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const resizeWebviewWithSafeArea = inject(
  PROVIDE_KEY_RESIZE_WEBVIEW
) as ResizeWebview;

const serviceStore = useServiceStore();

const termsList = ref<ITermsInfo[]>([]);
const selectedTerms = ref<ITermsInfo>();

const agreeAll = ref(false);
const isActive = () => {
  return (
    !!termsList.value.length &&
    !termsList.value
      .filter((terms) => !terms.hideCheckboxYn)
      .find((policy) => policy.required && !policy.agreeYn)
  );
};
const isAllAgree = () => {
  return !termsList.value
    .filter((terms) => !terms.hideCheckboxYn)
    .find((policy) => !policy.agreeYn);
};

const getTitle = (terms: ITermsInfo) => {
  const labelPrefix = terms.labelPrefix ?? (terms.required ? "필수" : "선택");
  const agreeText = terms.hideCheckboxYn ? "" : "동의";
  return `[${labelPrefix}] ${terms.title} ${agreeText}`;
};

const onChangedAgreementsAll = (checked: boolean) => {
  termsList.value = termsList.value.map((policy) => {
    policy.agreeYn = checked;
    return policy;
  });
};

const onClickTerms = (code: TermsTypeCode) => {
  selectedTerms.value = termsList.value?.find((terms) => terms.code === code);
  toggleShowTerms(true);
};

const shouldShowTerms = ref(false);
const toggleShowTerms = (show: boolean) => {
  shouldShowTerms.value = show;
};

const saveAgreedTerms = () => {
  const termsResult = termsList.value.map((termsInfo) => {
    return {
      agreeContent: "",
      agreeYn: termsInfo.agreeYn,
      agreeCode: termsInfo.code,
    };
  }) as ITermsResult[];

  useSetSessionStorageItem(SESSION_KEY_TERMS_RESULT, termsResult);
};

const handleSignup = () => {
  saveAgreedTerms();
  goToAuth();
};

const getTermsList = () => {
  termsList.value = serviceStore.agreeCodes.map((termsInfo) => {
    termsInfo.agreeYn = false;
    return termsInfo;
  });
};

watch(isAllAgree, (isAllAgree) => {
  agreeAll.value = isAllAgree;
});

const { addAuthScript, requestAuth } = useRequestAuth();

/** 본인인증 */
const goToAuth = () => {
  resizeWebviewWithSafeArea(true, 100);
  requestAuth("signup");
};

onMounted(() => {
  addAuthScript();
  getTermsList();
});

const __returned__ = { resizeWebviewWithSafeArea, serviceStore, termsList, selectedTerms, agreeAll, isActive, isAllAgree, getTitle, onChangedAgreementsAll, onClickTerms, shouldShowTerms, toggleShowTerms, saveAgreedTerms, handleSignup, getTermsList, addAuthScript, requestAuth, goToAuth, Page, NavigationBar, CheckboxInput, FooterButton, TermsDetail, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})